import React, { useState, useRef, useEffect } from 'react';
import { Link } from 'react-router-dom';

const GUIDES = [
  { label: 'Download Instagram Data', to: '/how-to-download-instagram-data' },
  { label: "Who Doesn't Follow You Back", to: '/how-to-see-who-doesnt-follow-you-back' },
  { label: 'Clean Up Your Following List', to: '/how-to-clean-up-your-following-list' },
  { label: 'Best Free Unfollow Tracker', to: '/best-free-instagram-unfollow-tracker' },
  { label: 'Why Apps Are Dangerous', to: '/why-instagram-third-party-apps-are-dangerous' },
  { label: 'Improve Your Follower Ratio', to: '/how-to-improve-instagram-follower-ratio' },
  { label: 'Instagram Account Audit', to: '/instagram-account-audit' },
  { label: 'Good Follower-Following Ratio', to: '/what-is-a-good-follower-following-ratio' },
];

const Navbar: React.FC = () => {
  const [guidesOpen, setGuidesOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const handleClickOutside = (e: MouseEvent) => {
      if (dropdownRef.current && !dropdownRef.current.contains(e.target as Node)) {
        setGuidesOpen(false);
      }
    };
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  return (
    <nav className="w-full bg-white/5 border-b border-white/10 backdrop-blur-sm">
      <div className="w-full px-6 h-12 flex items-center justify-between">
        <Link to="/" className="text-lg font-black tracking-tight ig-gradient-text">
          Purgr
        </Link>
        <div className="flex items-center gap-5 text-sm text-white/50">
          {/* Guides dropdown */}
          <div className="relative" ref={dropdownRef}>
            <button
              onClick={() => setGuidesOpen(o => !o)}
              className="flex items-center gap-1 hover:text-white/90 transition-colors"
            >
              Guides
              <span className={`transition-transform duration-150 ${guidesOpen ? 'rotate-180' : ''}`}>▾</span>
            </button>
            {guidesOpen && (
              <div className="absolute right-0 top-full mt-2 w-56 bg-[#1a0a1e] border border-white/10 rounded-xl shadow-xl py-1 z-50">
                {GUIDES.map(g => (
                  <Link
                    key={g.to}
                    to={g.to}
                    onClick={() => setGuidesOpen(false)}
                    className="block px-4 py-2.5 text-white/55 hover:text-white/90 hover:bg-white/5 transition-colors text-xs leading-snug"
                  >
                    {g.label}
                  </Link>
                ))}
              </div>
            )}
          </div>
          <Link to="/about" className="hover:text-white/90 transition-colors">About</Link>
          <Link to="/contact" className="hover:text-white/90 transition-colors">Contact</Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
